import { Checkbox } from '@mui/material'
import themeColors from '@const/colors.json'
import { withStyles } from '@mui/styles'

const StyledCheckbox = withStyles({
  root: {
    color: 'grey',
    '&:hover': {
      color: themeColors.blue3
    }
  }
})(Checkbox)

export default StyledCheckbox
